export default __webpack_public_path__ + "static/media/remove-btn-white.d72f7c91.svg";